import React from 'react';

interface InningSelectorProps {
  currentInning: number;
  totalInnings: number;
  onInningChange: (inning: number) => void;
}

export const InningSelector: React.FC<InningSelectorProps> = ({
  currentInning,
  totalInnings,
  onInningChange
}) => {
  const handlePrevious = () => {
    onInningChange(Math.max(1, currentInning - 1));
  };

  const handleNext = () => {
    onInningChange(Math.min(totalInnings, currentInning + 1));
  };

  return (
    <div className="flex items-center gap-1 sm:gap-2 mr-1 sm:mr-2">
      <label className="text-xs sm:text-sm font-medium">Inning:</label>
      <div className="flex items-center border rounded-lg overflow-hidden bg-white">
        <button
          onClick={handlePrevious}
          className="px-1.5 sm:px-2 py-1 bg-gray-100 hover:bg-gray-200 border-r text-xs sm:text-sm"
          disabled={currentInning <= 1}
        >
          -
        </button>
        <span className="px-2 sm:px-3 py-1 min-w-[30px] sm:min-w-[40px] text-center text-xs sm:text-sm">
          {currentInning}
        </span>
        <button
          onClick={handleNext}
          className="px-1.5 sm:px-2 py-1 bg-gray-100 hover:bg-gray-200 border-l text-xs sm:text-sm"
          disabled={currentInning >= totalInnings}
        >
          +
        </button>
      </div>
      <div className="text-xs sm:text-sm">of {totalInnings}</div>
    </div>
  );
}; 